import { PageRef } from 'providers/page-ref';
import { SendFeedbackType } from '@cf-shared/send-feedback-interface';

export type SendFeedbackPageParams = {
  sentryId?: string;
  type?: SendFeedbackType;
};

export const ISendFeedbackPage: PageRef<SendFeedbackPageParams, void> = {
  pageName: 'SendFeedbackPage',
} as PageRef<SendFeedbackPageParams, void>;
